module.exports = __webpack_public_path__ + "media/images/smart_phone/logo_gifu-9f15bcfdec63ee563254a46bb21ef4d4.png";